// extracted by mini-css-extract-plugin
module.exports = {"workspaceListItem":"suggested-workspace-step_workspaceListItem_I0H"};